import { BaseIntegration, BaseIntegrationData, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { Component } from 'vue';

export class IntegrationStockHandlingModel extends BaseIntegration<BaseIntegrationData, BaseIntegrationState> {
  getVueComponent(): Promise<Component> {
    return import('@/components/integrations/stockhandling/View.vue');
  }

  hasVueComponent() {
    return true;
  }

  authorSignature(): string {
    return 'Jannik Fischer';
  }
}
